import {
  Input,
  Inject,
  OnInit,
  Output,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import { OrderService } from 'services/order.service';

import orderCancelHtml from './order-cancel.html';
import './order-cancel.scss';

/**
 * Order cancellation form
 */
@Component({
  selector: 'gw-order-cancellation',
  template: orderCancelHtml,
})
export class FormOrderCancelComponent implements OnInit {
  public GW = (<any>window).GW;
  public form: ng.IFormController;
  public state = {
    email: '',
    orderNumber: '',
    error: '',
    success: false,
    loading: false,
  };

  constructor(
    @Inject(OrderService) private orderService: OrderService,
  ) {}

  ngOnInit() {

  }

  async submit() {
    if (this.form.$invalid) {
      return;
    }

    this.state.loading = true;

    try {
      const response = await this.orderService
        .cancelOrder(this.state.email, this.state.orderNumber);

      this.state.success = true;
    } catch (e) {
      const status = e ? e.status_code : null;

      if ([404, 409].includes(status)) {
        this.state.error = e.message || 'Something went wrong. Please try again.';
      } else {
        this.state.error = 'Something went wrong. Please try again.';
      }

      this.state.loading = false;
    }
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/order-cancel/order-cancel.component.ts